import React, { useState,useEffect }  from "react";
import Head from "../components/seo/Head";
import MerchantCarousel from "../components/common/MerchantCarousel";
import MerchantCards from "./merchants"
import { useDispatch, useSelector } from "react-redux";
import { fetchBusinessTypes } from "../features/master/masterThunks"; 
import { searchMerchantsThunk,clearSearchResults } from "../features/home/merchantSearchSlice";
import { fetchMerchantsThunk } from "../features/home/merchantListingSlice";
import WhyChooseUs from "./WhyChooseUs";
import LocationSearch from "./LocationSearch" 

const Home = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeCategory, setActiveCategory] = useState("All Merchants");
  const [filter, setFilter] = useState('');
  const [location, setLocation] = useState('');

  const handleSearch = () => {
    if (!searchTerm.trim()) {
      alert("Please enter something to search");
      return; }
    console.log("Searching for:", searchTerm);
    };

const dispatch = useDispatch();

const { businessTypes } = useSelector((state) => state.master);
useEffect(() => {
  dispatch(fetchBusinessTypes());
}, [dispatch]);


const handleCategorySelect = (item) => {
  setActiveCategory(item.name);

  dispatch(
    searchMerchantsThunk({
      businessTypeId: item._id,
      page: 1,
      limit: 50,
    })
  );
};

 
 const categoryIcons = {
  "All Merchants": "fas fa-store",
  Dealers: "fas fa-handshake",
  Distributers: "fas fa-boxes",
  "Education Sector": "fas fa-graduation-cap",
  "IT industry": "fas fa-microchip",
  Manufacturers: "fas fa-industry",
  Retailers: "fas fa-shopping-bag",
  "Service Providers": "fas fa-toolbox",
  Wholesellers: "fas fa-warehouse",
};
  return (
    <>
      <Head title="Home"
        description="Welcome to ICAME Frontend - Your secure and innovative web application"
        keywords="home, welcome, icame, react, frontend"
      />

      <div className="page">
        {/* Hero Section */}
        <MerchantCarousel />
        {/* merchant serch section */}
       {/* <div className="merchant-finder-section">
      <div className="decorative-curves">
        <div className="curve-top-left"></div>
        <div className="curve-top-right"></div>
        <div className="curve-bottom-left"></div>
        <div className="curve-bottom-right"></div>
        <div className="curve-center"></div>
      </div>  

      <div className="container">
        <div className="content-wrapper">
          <div className="row justify-content-center">
            <div className="col-12">
            
              <h1 className="main-title">
                Find Trusted Merchants Across India
              </h1>

           
              <p className="subtitle">
                Connect with verified local businesses from every corner of the country
              </p>

            
      <div className="categories-container">
     <div className="category-scroll">
    {["All Merchants", ...businessTypes.map((item) => item.name)].map(
      (category, index) => (
        <button
          key={index}
          className={`category-pill ${
            activeCategory === category ? "active" : ""
          }`}
         onClick={() => {
  setActiveCategory(category);

  if (category === "All Merchants") {
    dispatch(clearSearchResults());
    dispatch(fetchMerchantsThunk());
    return;
  }

  const selectedType = businessTypes.find((t) => t.name === category);

  if (selectedType) {
    dispatch(
      searchMerchantsThunk({
        businessTypeId: selectedType._id,
        page: 1,
        limit: 50,
      })
    );
  }
}}>
          <i className={`${categoryIcons[category] || "fas fa-tag"} category-icon`}></i>
          <span className="category-label">{category}</span>
        </button>
      )
    )}
  </div>
</div>
 </div>
</div>
</div>
</div>
</div> */}

{/* merchants  */}
      <MerchantCards/>

        {/* Features Section */}
         <WhyChooseUs />

    {/* location search */}
<LocationSearch/>


</div>
    </>
  );
};
export default Home;
